import { defaultFill } from './utils/constants';
var muiChevronRightBase = {
    paths: [
        {
            path: 'M0.29389313,11.7040359 C0.0979643766,11.5067265 0,11.2556054 0,10.9506726 C0,10.6457399 0.0979643766,10.3946188 0.29389313,10.1973094 L4.46183206,6 L0.29389313,1.80269058 C0.0979643766,1.60538117 0,1.35426009 0,1.04932735 C0,0.744394619 0.0979643766,0.493273543 0.29389313,0.295964126 C0.489821883,0.0986547085 0.739185751,0 1.04198473,0 C1.34478372,0 1.59414758,0.0986547085 1.79007634,0.295964126 L6.70610687,5.24663677 C6.8129771,5.35426009 6.88867684,5.47085202 6.93320611,5.59641256 C6.97773537,5.72197309 7,5.85650224 7,6 C7,6.14349776 6.97773537,6.27802691 6.93320611,6.40358744 C6.88867684,6.52914798 6.8129771,6.64573991 6.70610687,6.75336323 L1.79007634,11.7040359 C1.59414758,11.9013453 1.34478372,12 1.04198473,12 C0.739185751,12 0.489821883,11.9013453 0.29389313,11.7040359 Z',
            fill: defaultFill,
        },
    ],
    title: 'chevron right',
    width: 24,
    height: 24,
    rotate: 0,
    translate: [8, 6],
};
var muiChevronRight = {
    base: muiChevronRightBase,
};
export { muiChevronRight };
//# sourceMappingURL=chevronRight.js.map